import { machineServiceOne } from '../../../services/service-factory';

export default {
  data: function() {
    return {
      machineService: undefined
    };
  },
  created: function() {
    this.machineService = machineServiceOne;
  }
};
